const absoluteAlignment = (x, y) => `
  position: absolute;
  ${x ? `left: ${x}` : 0};
  ${y ? `top: ${y}` : 0};
  transform: translate(${x ? `-${x}` : 0}, ${y ? `-${y}` : 0});
`;

export { absoluteAlignment };
